import type { Accept } from "react-dropzone"
import { getBytesFromMegabytes } from "@/lib/upload"

// Threshold after which we consider a drop "open edition"
export const OPEN_EDITION_SUPPLY_THRESHOLD = 200_000_000
export const MAX_MINTABLE_MAX = 65_535 // uint16 max value

export enum DropStatus {
  MINTING_SOON = "MINTING_SOON",
  MINTING = "MINTING",
  MINTED_OUT = "MINTED_OUT",
  MINT_ENDED = "MINT_ENDED",
}

export const SALES_FEED_TABLE_COLUMN_CLASSNAMES = {
  image: "w-36 shrink-0 grow-0 gap-3 first:pl-0",
  price: "w-16 shrink-0 grow justify-end",
  seller: "w-16 shrink-0 grow justify-end",
  timestamp: "w-16 shrink-0 grow justify-end last:pr-0",
}

export const MINT_FEED_TABLE_COLUMN_CLASSNAMES = {
  item: "w-32 shrink-0 grow-0 gap-3 first:pl-0",
  price: "w-16 shrink-0 grow justify-end",
  quantity: "w-16 shrink-0 grow justify-end",
  timestamp: "w-16 shrink-0 grow justify-end last:pr-0",
}

export const dropItemMedia = {
  maxFileSize: getBytesFromMegabytes(50),
  maxFileCount: 15_000,
  accept: {
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "image/svg+xml": [".svg"],
    "image/gif": [".gif"],
    "video/mp4": [".mp4"],
    "audio/mpeg": [".mp3"],
  } satisfies Accept,
}

export const selfMintMedia = {
  maxFileSize: getBytesFromMegabytes(50),
  accept: {
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "image/svg+xml": [".svg"],
    "image/gif": [".gif"],
    "video/mp4": [".mp4"],
    "audio/mpeg": [".mp3"],
  } satisfies Accept,
}

export const collectionLogo = {
  maxFileSize: getBytesFromMegabytes(50),
  accept: {
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "image/svg+xml": [".svg"],
    "image/gif": [".gif"],
  } satisfies Accept,
}

export const csvUpload = {
  maxFileSize: getBytesFromMegabytes(10),
  accept: {
    "text/csv": [".csv"],
  } satisfies Accept,
}
